import { HTMLAttributes, useEffect, useState } from 'react';
import { QuoteRenewStatus } from '@jove-frontend/uikit';
import clsx from 'clsx';
import { capitalize } from 'lodash';

type QuoteRenewalStatusViewProps = HTMLAttributes<HTMLDivElement> & {
  label?: string;
  color?: string;
  status?: string;
};

const QuoteRenewalStatusView = (props: QuoteRenewalStatusViewProps) => {
  const { className, label, color, status } = props;
  const [containerStyle, setContainerStyle] = useState({});
  const [showText, setShowText] = useState('');

  /**
   * effects
   */
  useEffect(() => {
    evaluateTextInfo();
  }, [status]);

  /**
   * methods
   */
  const evaluateTextInfo = () => {
    let textColor = color;
    let showText = label || '';
    if (!textColor) {
      switch (status) {
        case QuoteRenewStatus.NOT_YET:
          textColor = '#D6D6D6';
          break;
        case QuoteRenewStatus.RENEW_SOON:
          textColor = '#DD1F1F';
          break;
        case QuoteRenewStatus.RENEWED:
          textColor = '#0E35D1';
          break;
        default:
          textColor = '#0E35D1';
          break;
      }
    }

    if (!label) {
      // Temp
      showText = status;
    }

    setShowText(showText);
    setContainerStyle({
      borderColor: `${textColor}`,
      color: `${textColor}`,
    });
  };

  if (!status) {
    return null;
  }

  return (
    <div
      style={containerStyle}
      className={clsx(
        'flex flex-row rounded-lg border px-[8px] py-[6px] text-sm font-bold',
        className
      )}
    >
      {capitalize(showText?.replaceAll('_', ' '))}
    </div>
  );
};

export default QuoteRenewalStatusView;
